import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-subscription-payment-failure-dialog',
  templateUrl: './subscription-payment-failure-dialog.component.html',
  styleUrls: ['./subscription-payment-failure-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionPaymentFailureDialogComponent {}
